
import dataReducer from '../Reducers/data';
import errorHandlerReducer from '../Reducers/errorHandler';
import loadingReducer from '../Reducers/loading';
import {createStore, combineReducers, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default () => {
    const store = createStore(
        combineReducers({
            data             : dataReducer,
            errorHandler     : errorHandlerReducer,
            loadingIndicator : loadingReducer


        }),
        composeEnhancers(applyMiddleware(thunk))
    );

    return store;
};




// WEBPACK FOOTER //
// ./src/Store/configureStore.js